export default {
  title: 'Aggiorna orario di consegna',
  labels: {
    dropoff_time: 'Orario di consegna',
    confirmed: 'Orario confermato:',
    new_time: 'Nuovo orario:',
  },
  buttons: {
    save: 'Salva',
  },
  toasts: {
    success: 'Orario di consegna aggiornato con successo',
    failed_to_save: 'Salvataggio modifiche fallito',
  },
  alerts: {
    dropoff_time_info: "L'orario attuale e quello nuovo sono nel fuso orario di {{restaurantName}} {{timezone}}",
  },
};
